import { Layout } from '../layouts/Layout';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import ShiftSettings from '../components/ShiftSettings';
import { useEmployees } from '../hooks/useEmployees';

/**
 * Shift Settings page component
 * Displays shift management interface for configuring employee schedules
 * Uses useEmployees hook for data fetching
 */
export default function ShiftSettingsPage() {
  const { employees, loading, error } = useEmployees();

  return (
    <Layout>
      <Sidebar />
      <Header title="Shift Settings" />

      <main className="ml-0 md:ml-64 pt-20 p-6">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Shift Settings</h1>
          <p className="text-gray-600">Kelola pengaturan shift untuk semua karyawan</p>
        </div>

        {/* Shift Settings Component */}
        {loading ? (
          <div className="flex items-center justify-center py-12">
            <div className="inline-flex items-center">
              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Loading employees...
            </div>
          </div>
        ) : error ? (
          <div className="flex items-center justify-center py-12 text-red-600">
            Error loading employees: {error}
          </div>
        ) : (
          <ShiftSettings employees={employees} />
        )}
      </main>
    </Layout>
  );
}
